
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/startup-events/[id]",
      function () {
        return require("private-next-pages/startup-events/[id]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/startup-events/[id]"])
      });
    }
  